import { defaultUnderlineStyle } from "@ui/css/common";

export const allResultsLinkStyles = {
    _hover: {
        "--b": "100%",
        ...defaultUnderlineStyle,
    },
    _active: {
        ...defaultUnderlineStyle,
    },
    fontSize: "desktopBodyTextNormal",
};

export const allResultsLinkMobileStyles = { display: ["flex", "none", "none"], pl: 3, my: 5 };

export const allResultsLinkDesktopStyles = {
    display: ["none", "flex", "flex"],
    mt: "auto",
};
